import type React from 'react';
import FaceliftText from '@/components/Atoms/FaceliftText/FaceliftText';
import { Tooltip } from '@/components/ui/tooltip';

export interface FaceliftTruncatedTextWithTooltipProps {
  text: string;
  maxLength?: number;
  fontSize?: string;
  fontWeight?: number | string;
  color?: string;
}

const FaceliftTruncatedTextWithTooltip: React.FC<
  FaceliftTruncatedTextWithTooltipProps
> = ({ text, maxLength = 30, fontSize = 'sm', fontWeight = 400, color }) => {
  const shouldTruncate = text && text.length > maxLength;
  const displayText = shouldTruncate ? `${text.slice(0, maxLength)}...` : text;

  if (!shouldTruncate) {
    return (
      <FaceliftText
        fontSize={fontSize}
        fontWeight={fontWeight}
        color={color}
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
      >
        {text}
      </FaceliftText>
    );
  }

  return (
    <Tooltip
      content={
        <FaceliftText
          fontSize="sm"
          fontWeight="400"
          wordBreak="break-word"
          maxW="400px"
        >
          {text}
        </FaceliftText>
      }
      positioning={{ placement: 'top' }}
      openDelay={200}
      contentProps={{
        px: 3,
        py: 2,
        borderRadius: '6px',
        _dark: { bg: 'white', color: 'black' },
        _light: { bg: 'gray.700', color: 'white' },
      }}
    >
      <FaceliftText
        fontSize={fontSize}
        fontWeight={fontWeight}
        color={color}
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        cursor="help"
      >
        {displayText}
      </FaceliftText>
    </Tooltip>
  );
};

export default FaceliftTruncatedTextWithTooltip;
